// extracted by mini-css-extract-plugin
export default {"wrapper":"navigation-menu_wrapper--bqC7X"};